import React from 'react';
export function IndexSlide() {
  const sections = [{
    number: '01',
    title: 'Cover',
    page: '01'
  }, {
    number: '02',
    title: 'Index',
    page: '02'
  }, {
    number: '03',
    title: 'The Problem',
    page: '03'
  }, {
    number: '04',
    title: 'The Solution',
    page: '04'
  }, {
    number: '05',
    title: 'Phase 1 – Operational Foundation',
    page: '05'
  }, {
    number: '06',
    title: 'System Architecture',
    page: '06'
  }, {
    number: '07',
    title: 'Driver Onboarding',
    page: '07'
  }, {
    number: '08',
    title: 'Motorcycle Activation',
    page: '08'
  }, {
    number: '09',
    title: 'Core Platform Modules',
    page: '09'
  }, {
    number: '10',
    title: 'Advanced Operations',
    page: '10'
  }, {
    number: '11',
    title: 'Control & Integrations',
    page: '11'
  }, {
    number: '12',
    title: 'Phase 2 – Data Integration',
    page: '12'
  }, {
    number: '13',
    title: 'National Impact & Value',
    page: '13'
  }, {
    number: '14',
    title: 'Implementation Roadmap',
    page: '14'
  }, {
    number: '15',
    title: 'Live Demo',
    page: '15'
  }, {
    number: '16',
    title: 'Thank You',
    page: '16'
  }];
  const leftColumn = sections.slice(0, 8);
  const rightColumn = sections.slice(8);
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-8 py-6" data-id="element-270">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-271">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-272" />
      </div>

      {/* Title */}
      <div className="text-center shrink-0 mb-10 mt-4" data-id="element-273">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-274">
          Overview
        </span>
        <h1 className="text-[1.5rem] font-bold text-[#1a1a2e] mt-1" data-id="element-275">Agenda</h1>
      </div>

      {/* Two-column index */}
      <div className="flex-grow flex items-start justify-center max-w-7xl mx-auto w-full gap-16 2xl:gap-24" data-id="element-276">
        {[leftColumn, rightColumn].map((column, colIdx) => <div key={colIdx} className="flex-1 flex flex-col gap-0" data-id="element-277">
            {column.map((item, idx) => <div key={idx} className="flex items-center gap-4 py-4 2xl:py-5 border-b border-gray-100 last:border-b-0 group" data-id="element-278">
                <span className="text-[0.85rem] 2xl:text-[1rem] font-bold text-[#2EBCB0] w-8 shrink-0 tabular-nums" data-id="element-279">
                  {item.number}
                </span>
                <span className="text-[0.95rem] 2xl:text-[1.1rem] text-gray-700 font-medium flex-grow group-hover:text-[#1a1a2e] transition-colors" data-id="element-280">
                  {item.title}
                </span>
                <span className="text-[0.8rem] 2xl:text-[0.9rem] text-gray-300 tabular-nums" data-id="element-281">
                  {item.page}
                </span>
              </div>)}
          </div>)}
      </div>

      {/* Bottom */}
      <div className="text-center shrink-0 mt-6" data-id="element-282">
        <p className="text-[0.75rem] text-gray-400" data-id="element-283">16 slides</p>
      </div>
    </div>;
}